// Models

export class UnitConfigViewModel {
	id: number | number;
	guid: string;
	name: string;
	description: string;
	enabled: boolean;
	type: string;
	settings?: SettingsViewModel[];
	channels?: ChannelViewModel[];
	unitId?: number;
	unitGuid: string;
	unitConfig: UnitConfigViewModel;
}

export class UnitConfigChannelDto {
	id: number;
	channelId: string;
	offset: number;
	gain: number;
}

export class SettingsViewModel {
	name: string;
	value: any;
	description: string;
}

export class ChannelViewModel {
	id: number | string;
	kind: number;
	displayKind: string;
	name: string;
	description: string;
	uom?: number;
	min?: number;
	max?: number;
	transform?: string;
	offset?: number;
	gain?: number;
	type?: string;
	enabled?: boolean;
	totalizer: TotalizerViewModel;
}

export class OutputChannelViewModel {
	name: string;
	enabled: boolean;
}

export class LegacyUnitConfigViewModel {
	Guid: string;
	Name: string;
	Description: string;
	Version: string;
	Configuration?: LegacyUnitConfigConfigurationViewModel;
}

export class LegacyUnitConfigConfigurationViewModel {
	PluginGuid: string;
	UnitId: string;
	UnitDescription: string;
	DeviceGuid: string;
	ExtraInfo: string[];
	Settings: SettingsViewModel[];
	Fields: ChannelViewModel[];
}

export class TotalizerViewModel {
	channelSourceName: string;
	totalizerBase: number;
	totalizerCalcFactor: number;
}
